module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Basic Details","action":{"update":"Update details"},"alert":{"success":"User details saved!"}}}')
  delete Component.options._Ctor
}
